// extracted by mini-css-extract-plugin
module.exports = {"container":"CardContainer_container__28Zcr","title":"CardContainer_title__38lYy","subTitle":"CardContainer_subTitle__1APv5"};